import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ws_ticket: {
      id: null,
      client: null,
      expires: null,
      namespace: null
    },
    ws_connected: false,
    key: '',

    // store list of WS messages to add as buttons to dashboard
    ws_messages: [
      {
        label: 'view attacks',
        channel: 'broadcast',
        message: 'view attacks'
      },
      {
        label: 'view traffic',
        channel: 'broadcast',
        message: 'view traffic'
      },
      {
        label: 'view sessions',
        channel: 'broadcast',
        message: 'view sessions'
      },
      {
        label: 'run test pattern A',
        channel: 'broadcast',
        message: 'test pattern A'
      },
      {
        label: 'run test pattern B',
        channel: 'broadcast',
        message: 'test pattern B'
      },
      {
        label: 'run test pattern C',
        channel: 'broadcast',
        message: 'test pattern C'
      },
      {
        label: 'stop test patterns',
        channel: 'broadcast',
        message: 'stop test patterns'
      }
    ]
  },
  mutations: {
    SET_WS_TICKET (state, tkt) {
      state.ws_ticket.client = tkt.client;
      state.ws_ticket.namespace = tkt.namespace;
      state.ws_ticket.id = tkt.id;
      state.ws_ticket.expires = tkt.expires;
    },
    SET_ACCESS_KEY (state, key) {
      state.key = key;
    },
    SET_CONNECTED (state, connected) {
      state.ws_connected = connected;
    }
  },
  actions: {

  }
});
